module.exports = __webpack_public_path__ + "2111c08f5ddd8c818a4e4a7afd69fa69.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/smoothie.png
// module id = 2737
// module chunks = 0